function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { urlPush, buildHref, withRouter } from '@shared/routerHistory';
import { changeBillingRegion, getUserAuthStatus, performSearchAll } from '@shared/actions/thunkActions';
import { createSearchboxInputChangedAction, createSearchDataReceivedAction, createModalAction, createVideoModalAction, createAppViewTelemetryLoggedAction, createRatingAction, createSearchSortingOptionChangedAction, createBreadcrumbAction, createSetIsNpsLogicVerifiedAction, createChangeLocaleLanguage } from '@shared/actions/actions';
import { AppView as AppViewComponent } from '@shared/components/appView';
import { Constants } from '@shared/utils/constants';
import { queryChanged } from '@shared/actions/queryThunkActions';
import { getAllEntityTypes, getEntityRegistrationByView } from '@shared/utils/entityRegistration';
import { getTelemetryDetailContentCurrentView } from '@shared/utils/appUtils';
import { connect } from 'react-redux';
import { saveCookieItem } from '@shared/utils/browserStorageUtils';
import { getUserFavouriteViewEntityList } from '@shared/utils/userFavouriteUtils';
export const mapStateToProps = (state, ownProps)=>{
    const userFavorites = state.userFavourite;
    const viewApps = getUserFavouriteViewEntityList(userFavorites.apps);
    const viewServices = getUserFavouriteViewEntityList(userFavorites.services);
    return {
        isConverged: state.config.isConverged,
        initLoading: state.config.initLoading,
        searchSortingOption: state.search && state.search.searchSortingOption,
        performedSubsetQueryString: state.apps && state.apps.subsetSearchQuery,
        localizedStrings: state.config.locStrings,
        locale: state.config.locale,
        isEmbedded: state.config.isEmbedded,
        storefrontName: state.config.storefrontName,
        refreshToken: state.users.refreshToken,
        homeAccountId: state.users.homeAccountId,
        embedHost: state.config.embedHost,
        enableNewNps: state.config.newNpsEnabled,
        npsLogicVerified: state.config.npsLogicVerified,
        correlationId: state.config.correlationId,
        // eslint-disable-next-line @typescript-eslint/ban-types
        buildHref: function(route, routeParams, newQuery, keepAllParams, oldParams, keepCampaignParams) {
            return buildHref(route, ownProps.params, routeParams, oldParams || ownProps.location.query, newQuery, keepAllParams, state.config.locale, keepCampaignParams);
        },
        locationQuery: _object_spread({}, ownProps.location.query || {}, ownProps.params || {}),
        entityId: state.modal.entityId,
        showModal: state.modal.showModal,
        userInfo: state.users,
        isInErrorDialog: state.modal.modalId === Constants.ModalType.Error,
        telemetryLoggedCount: state.config.appViewTelemetryLoggedCount,
        nationalCloud: state.config.nationalCloud,
        entityType: getEntityRegistrationByView(state.config.currentView),
        isMobile: state.config.isMobile,
        currentView: getTelemetryDetailContentCurrentView(state.config.currentView, state.config.currentGalleryViewIsCurated),
        allApps: state.apps ? state.apps.dataList : null,
        tileDataRequestId: state.apps ? state.apps.tileDataRequestId : '',
        uiRole: state.users.profile && state.users.profile.uiRole,
        regionCode: state.config.billingCountryCode,
        regionDisabled: state.config.isDisabledBilling,
        favoritesCount: viewApps.length + viewServices.length,
        pcaInstanceInitialized: state.config.pcaInstanceInitialized
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        searchSortingOptionChanged: (searchSortingOption)=>dispatch(createSearchSortingOptionChangedAction({
                searchSortingOption
            })),
        changeSearchText: (searchvalue)=>dispatch(createSearchboxInputChangedAction({
                searchString: searchvalue
            })),
        updateQuery: (query)=>dispatch(queryChanged(query)),
        performSearchAll: (searchvalue, searchSortingOption)=>dispatch(performSearchAll(searchvalue, searchSortingOption)),
        clearSearch: ()=>{
            getAllEntityTypes().forEach((entityType)=>{
                dispatch(createSearchDataReceivedAction({
                    entityType,
                    entityIdData: [],
                    performedQuery: ''
                }));
            });
        },
        showCTAModal: ({ entityId, entityType, ctaType, skuId, planId, isOpenedFromPDP, ribbonKey })=>{
            dispatch(createModalAction({
                showModal: true,
                modalId: Constants.ModalType.CTA,
                entityId,
                options: {
                    ctaType,
                    skuId,
                    planId,
                    ribbonKey
                },
                entityType,
                isOpenedFromPDP
            }));
        },
        showHowItWorksModal: ()=>{
            dispatch(createVideoModalAction({
                showModal: true,
                videoThumbnail: null,
                videoUrl: 'https://aka.ms/spzavideo',
                videoName: 'How It Works'
            }));
        },
        showErrorModal: ()=>{
            dispatch(createModalAction({
                showModal: true,
                modalId: Constants.ModalType.Error
            }));
        },
        showNPSModal: ()=>{
            dispatch(createModalAction({
                showModal: true,
                modalId: Constants.ModalType.NPS
            }));
        },
        showAnimationModal: ()=>{
            dispatch(createModalAction({
                showModal: true,
                modalId: Constants.ModalType.Animation
            }));
        },
        showRaingsModal: (app, accessKey, ctaType, callback)=>{
            dispatch(createRatingAction({
                showModal: true,
                app,
                accessKey,
                ctaType,
                callback
            }));
        },
        showReportAbuseModal: (appId, reviewId, reviewTitle, reviewSource)=>{
            dispatch(createModalAction({
                showModal: true,
                modalId: Constants.ModalType.ReportAbuse,
                options: {
                    appId,
                    reviewId,
                    reviewTitle,
                    reviewSource
                }
            }));
        },
        updateTelemetryLoggedCount: ()=>dispatch(createAppViewTelemetryLoggedAction(null)),
        openTile: (detailUrl)=>{
            const breadcrumbUrl = '';
            dispatch(createBreadcrumbAction({
                breadcrumbUrl
            }));
            urlPush(detailUrl, true);
        },
        getUserAuthStatus: ()=>{
            return dispatch(getUserAuthStatus());
        },
        setIsNpsLogicVerified: (verified)=>dispatch(createSetIsNpsLogicVerifiedAction({
                verified
            })),
        openSignInModal: ()=>{
            return dispatch(createModalAction({
                showModal: true,
                modalId: Constants.ModalType.SignIn
            }));
        },
        onMarketChange: (countryCode)=>{
            saveCookieItem(Constants.Cookies.billingRegionCookie, countryCode);
            return dispatch(changeBillingRegion({
                countryCode
            }));
        },
        onLocaleChange: (locale)=>{
            saveCookieItem(Constants.Cookies.LocaleCookie, locale);
            const pathSegments = window.location.pathname.split('/');
            pathSegments[1] = locale;
            const url = `${pathSegments.join('/')}${window.location.search}`;
            window.location.href = url;
            return dispatch(createChangeLocaleLanguage({
                locale
            }));
        },
        dispatch
    };
};
const AppView = withRouter(connect(mapStateToProps, mapDispatchToProps)(AppViewComponent));
export default AppView;
